// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3vkeQ","topBottomGutter":"Layout_topBottomGutter__3dB5q"};